import useSWR from "swr";
import { getData, putData } from "../backend";
import { User, Permission, Team, TeamSummary, UserProfile } from "../interfaces";
import { ONBOARDING_STEPS, OnboardingStep } from "../components/onboarding/constants";
import { getAuthToken } from "../auth";
import type { SWRConfiguration } from 'swr'


// User
// -> User === undefined (loading)
// -> User === null (not logged in)

function getUserData(path: string) {
  const hasAuthToken = !!getAuthToken();
  if (!hasAuthToken)
    return null;

  return getData(path);
}

export default function useUser(options?: SWRConfiguration) {
  const { data: user, mutate: refreshUser, ...rest } = useSWR<User | null>("/auth/whoami/", getUserData, options ?? {});

  function hasPermission(team: Team | TeamSummary | null | undefined, p: Permission): boolean {
    if (!team && p === "system.debug")
      return !!user?.permissions.includes(p);

    return !team || !!user?.permissions.includes(p);
  }

  async function markOnboardingComplete(currentStage?: OnboardingStep, profileUpdate: Partial<UserProfile> = {}) {
    if (user?.profile?.onboardingCompleted)
      return;

    await putData("/auth/profile/", {
      ...(user?.profile ?? {}),
      ...profileUpdate,
      onboardingCompleted: true,
      onboardingCurrentStage: currentStage ?? ONBOARDING_STEPS.REVEAL,
    });
    await refreshUser();
  }

  return { user, refreshUser, hasPermission, markOnboardingComplete, ...rest };
}
